/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import {
  alertController,
} from '@ionic/vue';
import axios from 'axios';
import AppConst from '../constants/app.constant';
import capacitorService from './capacitor.service';
import ConfigDeviceSettings from '../config/device.config';
import { getServiceHostPreference } from './utils/getServiceHostPreference';

const updateRequiredService = () => {
  const content = {};
  // AppConst.application.version
  // * <ul>
  // *    <li>0 if the versions are equal</li>
  // *    <li>a negative integer iff v1 < v2</li>
  // *    <li>a positive integer iff v1 > v2</li>
  // *    <li>NaN if either version string is in the wrong format</li>
  // * </ul>
  content.isVersionUpdateAvailable = (comparisonOutcome) => (comparisonOutcome < 0);

  content.versionCompare = (v1, v2, options) => {
    const lexicographical = options && options.lexicographical;
    const zeroExtend = options && options.zeroExtend;
    let v1parts = v1.split('.');
    let v2parts = v2.split('.');
    let i;

    function isValidPart(x) {
      const testObj = (lexicographical
        ? /^\d+[A-Za-z]*$/
        : /^\d+$/);
      const testResult = testObj.test(x);
      return testResult;
    }

    if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
      return NaN;
    }

    if (zeroExtend) {
      while (v1parts.length < v2parts.length) {
        v1parts.push('0');
      }
      while (v2parts.length < v1parts.length) {
        v2parts.push('0');
      }
    }

    if (!lexicographical) {
      v1parts = v1parts.map(Number);
      v2parts = v2parts.map(Number);
    }
    i = 0;
    while (i < v1parts.length) {
      if (v2parts.length === i) {
        return 1;
      }
      if (v1parts[i] === v2parts[i]) {
        i += 1;
      } else if (v1parts[i] > v2parts[i]) {
        return 1;
      } else {
        return -1;
      }
    }

    if (v1parts.length !== v2parts.length) {
      return -1;
    }

    return 0;
  };
  content.extractVersionInformation = (data) => {
    let latestVersionAvailable = 0;
    if (data && data.resultCount && data.results && data.results[0]) {
      latestVersionAvailable = data.results[0].version;
    }
    return latestVersionAvailable;
  };
  content.getVersionInformation = async () => {
    if (ConfigDeviceSettings.settings.enableSimulationUpdateRequired) {
      return ConfigDeviceSettings.settings.simulateUpdateRequiredValue;
    }
    const responseFinal = await axios.get(`${getServiceHostPreference()}/api/it-lookup/?bundleId=net.buser.weatherspork`, {
      headers: {
        'Content-Type': 'application/text',
      },
    }).then((response) => {
      if (response && response.data) {
        return content.extractVersionInformation(response.data);
      }
      return null;
    }).catch(() => Promise.reject(new Error('Not able to fetch bundle version')));
    return responseFinal;
  };
  content.openStore = () => {
    // isIOS      itms-apps://itunes.apple.com/us/app/apple-store/id1196062772
    // android    https://play.google.com/store/apps/details?id=net.buser.weatherspork
    if (capacitorService.isIos) {
      window.open('itms-apps://itunes.apple.com/us/app/apple-store/id1196062772', '_system');
    } else if (capacitorService.isAndroid) {
      window.open(
        'https://play.google.com/store/apps/details?id=net.buser.weatherspork',
        '_system',
      );
    }
  };
  content.checkIfUpdateIsRequired = () => {
    if (capacitorService.isCapacitorMobileApp && !window.TFDetect?.isTFXC) {
      content.getVersionInformation().then((latestVersionAvailable) => {
        if (latestVersionAvailable) {
          const comparisonOutcome = content.versionCompare(
            AppConst.application.version,
            latestVersionAvailable,
          );
          if (content.isVersionUpdateAvailable(comparisonOutcome)) {
            const buttons = [{
              text: 'Update',
              handler() {
                content.openStore();
                content.checkIfUpdateIsRequired();
              },
            }];
            if (ConfigDeviceSettings.settings.enableSimulationUpdateRequired) {
              buttons.push({
                text: 'Cancel',
              });
            }
            alertController.create({
              header: 'Update is available!',
              backdropDismiss: false,
              message: 'A new version of WeatherSpork is available.',
              buttons,
            }).then((alert) => {
              alert.present();
            });
          }
        }
      });
    }
  };
  return content;
};
export default updateRequiredService();
